import styles from './AssetNameRenderer.module.scss';
import { VdsIcon } from '@volt/volt-extended-components-react';
import { ReactElement } from 'react';
import { EmptyCell } from '../../formatters/genericFormatters';

export function AssetNameRenderer({
  value,
}: {
  value: [string | null | undefined, boolean];
}): ReactElement | string {
  if (value[0] != null && value[1] === true) {
    return (
      <div className={styles.withTooltip}>
        {value[0]}
        <VdsIcon color="color-icon-medium" svgIcon="information" size="20px" />
      </div>
    );
  }

  return value[0] ?? EmptyCell;
}

export default AssetNameRenderer;
